import { Component, OnInit } from "@angular/core";
import { HistoricoAtualizacoes } from "src/app/models/HistoricoAtualizacoes";
import { HistoricoAtualizacoesService } from "src/app/services/historico-atualizacoes.service";
import { HistoricoAtualizacoesDialogComponent } from "../../popups/historico-atualizacoes-dialog/historico-atualizacoes-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { Observable, of } from "rxjs";
import { ErrorHandlerService } from "src/app/services/errorHandler.service";

@Component({
  selector: "app-historico-atualizacoes",
  templateUrl: "./historico-atualizacoes.component.html",
  styleUrls: ["./historico-atualizacoes.component.scss"],
})
export class HistoricoAtualizacoesComponent implements OnInit {
  public historicoAtualizacoes$: Observable<HistoricoAtualizacoes[]> = of([]);

  constructor(
    private historicoAtualizacoesService: HistoricoAtualizacoesService,
    private errorHandlerService: ErrorHandlerService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.historicoAtualizacoes$ =
      this.historicoAtualizacoesService.getHistoricoAtualizacoesAll();
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(HistoricoAtualizacoesDialogComponent, {
      data: {},
      autoFocus: false,
      panelClass: "custom-historico-dialog-class",
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      this.historicoAtualizacoesService
        .getdata()
        .then(() => {})
        .catch((error) => this.errorHandlerService.handleError(error));
      this.historicoAtualizacoesService
        .updateHistoricoAtualizacoesLeis()
        .then(() => {})
        .catch((error) => this.errorHandlerService.handleError(error));
    });
  }
}
